import { FC, useMemo } from 'react';
import { DollarCircleOutlined } from '@ant-design/icons';
import { PMCountBuyAndSellChartProps } from '../../../../../../core/domain/overview/pm-count-buy-and-sell';
import { ChartCard } from '../../components/chart-card/chart-card';
import { BarSeriesChart, CHART_COLORS, faNumber, mergeByDate, sumOf } from '../chart-commons';

interface Props {
    chartData: PMCountBuyAndSellChartProps;
    chartLoading: boolean;
}

const series = [
    { key: 'buys', name: 'خرید', color: CHART_COLORS.green },
    { key: 'sells', name: 'فروش', color: CHART_COLORS.red },
];

export const PMCountBuyAndSell: FC<Props> = ({ chartData, chartLoading }) => {
    const data = useMemo(
        () =>
            mergeByDate([
                { key: 'buys', data: chartData?.buys },
                { key: 'sells', data: chartData?.sells },
            ]),
        [chartData],
    );

    return (
        <ChartCard
            title="تعداد خرید و فروش های یو ووچر"
            subtitle="تعداد سفارش‌های یو ووچر به تفکیک روز"
            icon={<DollarCircleOutlined />}
            accent="amber"
            loading={chartLoading}
            empty={!data.length}
            stats={[
                { label: 'خرید', value: faNumber(sumOf(data, 'buys')), color: CHART_COLORS.green },
                { label: 'فروش', value: faNumber(sumOf(data, 'sells')), color: CHART_COLORS.red },
            ]}
        >
            <BarSeriesChart data={data} series={series} />
        </ChartCard>
    );
};
